// API Service Layer
// This file provides a centralized location for all API calls
// Currently using mock data, but structured to easily switch to real backend APIs

import { mockAPI } from '../mock/mock';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Toggle between mock and real API
const USE_MOCK = true; // Set to false when backend is ready

// Shared POST for the form endpoints. The relative URL resolves to the Express
// server in local dev (via src/setupProxy.js) and to the Vercel serverless
// function in production.
const postForm = async (url, payload) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(payload)
  });

  const data = await response.json().catch(() => null);

  if (!response.ok || !data?.success) {
    throw new Error(data?.message || 'Something went wrong. Please try again.');
  }

  return data;
};

const apiService = {
  // Hero Section
  getHeroData: async () => {
    if (USE_MOCK) return mockAPI.getHeroData();
    // Real API call (to be implemented)
    // const response = await fetch(`${API_BASE}/hero`);
    // return response.json();
  },

  // Services
  getServices: async () => {
    if (USE_MOCK) return mockAPI.getServices();
    // Real API call (to be implemented)
    // const response = await fetch(`${API_BASE}/services`);
    // return response.json();
  },

  // Products
  getProducts: async () => {
    if (USE_MOCK) return mockAPI.getProducts();
    // Real API call (to be implemented)
    // const response = await fetch(`${API_BASE}/products`);
    // return response.json();
  },

  // Technologies
  getTechnologies: async () => {
    if (USE_MOCK) return mockAPI.getTechnologies();
    // Real API call (to be implemented)
    // const response = await fetch(`${API_BASE}/technologies`);
    // return response.json();
  },

  // Team
  getTeam: async () => {
    if (USE_MOCK) return mockAPI.getTeam();
    // Real API call (to be implemented)
    // const response = await fetch(`${API_BASE}/team`);
    // return response.json();
  },

  // Testimonials
  getTestimonials: async () => {
    if (USE_MOCK) return mockAPI.getTestimonials();
    // Real API call (to be implemented)
    // const response = await fetch(`${API_BASE}/testimonials`);
    // return response.json();
  },

  // Contact Info
  getContactInfo: async () => {
    if (USE_MOCK) return mockAPI.getContactInfo();
    // Real API call (to be implemented)
    // const response = await fetch(`${API_BASE}/contact`);
    // return response.json();
  },

  // Stats
  getStats: async () => {
    if (USE_MOCK) return mockAPI.getStats();
    // Real API call (to be implemented)
    // const response = await fetch(`${API_BASE}/stats`);
    // return response.json();
  },

  // Submit Contact Form ("Get in Touch" section)
  submitContactForm: async (formData) => {
    return postForm(BACKEND_URL ? `${API_BASE}/contact` : '/api/contact', formData);
  },

  // Submit Demo Request ("Our Products" section)
  submitDemoRequest: async (formData) => {
    return postForm(BACKEND_URL ? `${API_BASE}/demo-request` : '/api/demo-request', formData);
  }
};

export default apiService;